/**
 * Lightweight i18n for lightshow client.
 * Detects language from URL param (?lang=de) or browser language.
 * Default: English.
 */

const translations = {
  en: {
    waitingFor: 'Waiting for',
    toStart: 'to start...',
    loadingShow: 'Loading show...',
    holdPhoneUp: 'Hold your phone up!',
    holdPhoneUpWaiting: 'Hold your phone up as soon as the countdown starts!',
    startingSoon: 'Lightshow starting soon...',
    startingIn: 'Lightshow starting in...',
    paused: 'Paused — hold on',
    keepScreenOn: 'Keep your screen on',
    maxBrightness: 'Set your screen to maximum brightness and keep it on',
    thanks: 'Thanks for participating!',
    redirecting: 'Redirecting...',
    backToApp: 'Back to Pipeup',
    returningToIdle: '...',
    navigateTo: 'Navigate to',
    toJoinShow: 'to join a show.',
    failedToPrepare: 'Failed to prepare show',
    playbackError: 'Playback error',
    somethingWrong: 'Something went wrong',
    selectSector: 'I am in sector',
    enterRow: 'I am in row',
    waitingForShow: 'Waiting for show...',
    confirm: 'Confirm',
    change: 'Change',
  },
  de: {
    waitingFor: 'Warte auf',
    toStart: '...',
    loadingShow: 'Show wird geladen...',
    holdPhoneUp: 'Halte dein Handy hoch!',
    holdPhoneUpWaiting: 'Halte dein Handy hoch, sobald der Countdown startet!',
    startingSoon: 'Lichtshow startet gleich...',
    startingIn: 'Lichtshow startet in...',
    paused: 'Pausiert — bleib bereit',
    keepScreenOn: 'Bildschirm anlassen',
    maxBrightness: 'Stelle auf maximale Helligkeit und lass den Bildschirm an',
    thanks: 'Danke fürs Mitmachen!',
    redirecting: 'Weiterleitung...',
    backToApp: 'Zurück zu Pipeup',
    returningToIdle: '...',
    navigateTo: 'Navigiere zu',
    toJoinShow: 'um teilzunehmen.',
    failedToPrepare: 'Show konnte nicht geladen werden',
    playbackError: 'Wiedergabefehler',
    somethingWrong: 'Etwas ist schiefgelaufen',
    selectSector: 'Ich bin in Sektor',
    enterRow: 'Ich bin in Reihe',
    waitingForShow: 'Warte auf Show...',
    confirm: 'Bestätigen',
    change: 'Ändern',
  },
};

function detectLanguage() {
  // 1. URL param ?lang=de
  const params = new URLSearchParams(window.location.search);
  const langParam = params.get('lang');
  if (langParam && translations[langParam]) return langParam;

  // 2. Browser language
  const browserLang = (navigator.language || '').split('-')[0];
  if (translations[browserLang]) return browserLang;

  return 'en';
}

const currentLang = detectLanguage();

/**
 * Get translated string by key.
 * Falls back to English if key not found in current language.
 */
export function t(key) {
  return translations[currentLang]?.[key] || translations.en[key] || key;
}

export function getLang() {
  return currentLang;
}
